<template>
	<div class="popular" v-if="isMobile">
		<header class="popular-header">
			<h3 class="type--sans type--r type--b">Popular Searches</h3>
		</header>
		<ul class="popular-list">
			<li
				v-for="option in options"
				:key="option.id"
				class="popular-item"
				@click="$emit('select', option)"
			>
				<div class="popular-item__icon">
					<component :is="icon" />
				</div>
				<SelectOption :primary="option.name" :secondary="option.address" />
			</li>
		</ul>
	</div>
</template>

<script>
import popularAirports from "@/services/popularAirports"
import popularHeliports from "@/services/popularHeliports"
import SelectOption from "@/components/formfields/SelectOption"
import AirportIconWithBorder from "@/assets/flyt-icons_airport--border.svg?inline"
import HelipadIconWithBorder from "@/assets/flyt-icons_heliport--border.svg?inline"
import { mapGetters } from "vuex"

export default {
	name: "PopularSearches",

	components: {
		SelectOption,
		AirportIconWithBorder,
		HelipadIconWithBorder,
	},

	computed: {
		...mapGetters("browser", ["isMobile"]),
		...mapGetters("bookingForm", ["aircraftCategory"]),

		icon() {
			let icon

			if (this.aircraftCategory === 'aeroplane')
				icon = AirportIconWithBorder

			if (this.aircraftCategory === 'helicopter')
				icon = HelipadIconWithBorder
			
			return icon
		},

		options() {
			let searches

			if (this.aircraftCategory === 'aeroplane')
				searches = popularAirports

			if (this.aircraftCategory === 'helicopter')
				searches = popularHeliports
			
			return searches
		}
	}
}
</script>

<style lang="scss" scoped>
.popular {
	left: 2rem;
	position: absolute;
	top: 3rem;
	.is-mobile & {
		bottom: 0;
		left: 0;
		overflow-x: hidden;
		overflow-y: auto;
		top: 5rem;
		width: 100%;
	}
}

.popular-header {
	background: $colour-stone;
	padding: 0.75rem;
}

.popular-item {
	align-items: center;
	display: flex;
	flex-direction: row;
}

.popular-item__icon {
	fill: $colour-teal;
	height: 1.5rem;
	margin: 0.75rem 0 0.75rem 0.75rem;
	width: 1.5rem;
}
</style>
